<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@resetPassword">Reset Password</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<div i18n="@@pleaseEnterNewPasswordToResetPassword" class="text-center dialog-sub-title mat-caption">Please enter a new password to reset your password.</div>

<mat-dialog-content>
  <form [formGroup]="resetPasswordForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@newPasswordLabel">New Password</mat-label>
      <input data-testid="reset_password_new_password" #password [type]="hide ? 'password' : 'text'" matInput id="password" i18n-placeholder="@@newPasswordPlaceholder" placeholder="New Password" name="password" type="password" formControlName="password" required />
      <mat-hint align="end" [class]="meterMessage">
        {{meterMessage}}
      </mat-hint>
      <mat-icon 
        class="cursor" 
        matSuffix 
        (click)="hide = !hide" 
        i18n-aria-label 
        [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
        {{hide ? 'visibility' : 'visibility_off'}}
      </mat-icon>
      <mat-error>
        @if (!resetPasswordForm.get('password').valid && resetPasswordForm.get('password').touched) {
          @if (resetPasswordForm.get('password').errors['required']) {
            <span i18n="@@inValidRequiredField">This field is required</span>
          }
        }
        @if (resetPasswordForm.get('password').errors && resetPasswordForm.get('password').errors['pattern']) {
          <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
        }
      </mat-error>
    </mat-form-field>
    <div style="display: none">
      <password-strength-meter
        *ngIf="resetPasswordForm?.get('password')"
        [password]="resetPasswordForm.get('password').value"
        (strengthChange)="onStrengthChanged($event)">
      </password-strength-meter>
    </div>
    <mat-dialog-actions>
      <button i18n="@@resetPassword" data-testid="reset_password_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Reset Password</button>
    </mat-dialog-actions>
  </form>
